import get from 'lodash/get';
import { ProfileState } from '../States';
import { ProfileTypes } from '../Types';
import TextUtils from '../../utils/TextUtils';
import { updateState } from '../Store';
import {
  updateJobCategory,
  updateUserDetails,
  updateUserProfile,
  updateLocalities,
  updateUserExp,
  updateSelectedSkills,
  updateJobPref,
  updateOTP,
  updatePendingDocs,
  removePendingDocs,
  setJobCategories,
} from './Helper/ProfileReducerHelper';
import AuthService from '../../services/AuthService';

export default function(state = ProfileState, action) {
  switch (action.type) {
    case ProfileTypes.SET_ERROR:
      return { ...state, error: get(action, 'payload.error') };
    case ProfileTypes.SET_INFO:
      return { ...state, info: get(action, 'payload.info') };
    case ProfileTypes.SET_SUCCESS_MESSAGE:
      return { ...state, success: get(action, 'payload.success') };
    case ProfileTypes.RESET_ERROR:
      return { ...state, error: {} };
    case ProfileTypes.RESET_INFO:
      return { ...state, info: {} };
    case ProfileTypes.RESET_SUCCESS_MESSAGE:
      return { ...state, success: {} };
    case ProfileTypes.SELECT_PREFERRED_LANGUAGE:
      return { ...state, selectedLanguage: action.payload };
    case ProfileTypes.ON_CHANGE_USERNAME:
      return updateState(state, { userName: action.payload });
    case ProfileTypes.ON_CHANGE_GENDER:
      return {
        ...state,
        gender: action.payload,
      };
    case ProfileTypes.ON_CHANGE_MOBILE:
      return {
        ...state,
        userMobile: action.payload,
        isValidNumber: TextUtils.isValidMobile(action.payload),
      };
    case ProfileTypes.ON_CHANGE_OTP:
      return updateOTP(state, action.payload);
    case ProfileTypes.IS_API_PROGRESS:
      return {
        ...state,
        isAPIProgress: action.payload,
      };
    case ProfileTypes.ON_CHANGE_AGE:
      return updateState(state, { userAge: action.payload });
    case ProfileTypes.ON_SELECT_CITY:
      return updateState(state, { userWorkCity: action.payload });
    case ProfileTypes.PROFILE_PATCH_RESPONSE:
      return updateUserProfile(state, action.payload);
    case ProfileTypes.PROFILE_PATCH_ERROR:
      return updateState(state, { error: action.payload });
    case ProfileTypes.FETCHING_LOCATION:
      return updateState(state, { isFetchLocation: action.payload });
    case ProfileTypes.ON_SELECT_QUAL:
      return updateState(state, { qualification: action.payload });
    case ProfileTypes.ON_SELECT_JOB_DURATION:
      return updateState(state, { jobDuration: action.payload });
    case ProfileTypes.ON_SELECT_JOB_CATEGORY:
      return updateJobCategory(state, action.payload);
    case ProfileTypes.UPDATE_USER_DETAILS:
      return updateUserDetails(state, action.payload);
    case ProfileTypes.ON_SELECT_JOB_LOCALITIES:
      return updateLocalities(state, action.payload);
    case ProfileTypes.UPDATE_USER_EXP:
      return updateUserExp(state, action.payload);
    case ProfileTypes.ON_SELECT_SKILLS:
      return updateSelectedSkills(state, action.payload);
    case ProfileTypes.ON_SELECT_JOB_TYPE:
      return updateState(state, { userJobPref: { ...state.userJobPref, jobType: action.payload } });
    case ProfileTypes.ON_SELECT_JOB_PREF:
      return updateJobPref(state, action.payload);
    case ProfileTypes.TOGGLE_EDIT_PROFILE:
      return updateState(state, { currentEditItem: action.payload });
    case ProfileTypes.TOGGLE_WARNING:
      return updateState(state, { currentWarningItem: action.payload });
    case ProfileTypes.PENDING_DOCS:
      return updatePendingDocs(state, { ...action.payload });
    case ProfileTypes.REMOVE_PENDING_DOC:
      return removePendingDocs(state, { ...action.payload });
    case ProfileTypes.SET_JOB_CATEGORIES:
      return setJobCategories(state, action.payload);
    case ProfileTypes.SET_JOB_REQUIREMENTS:
      return updateState(state, { requirements: action.payload });
    case ProfileTypes.SALARY_SELECTED:
      return updateState(state, { selectedSalary: action.payload });
    case ProfileTypes.RESET_USER_ENTRY:
      return updateState(state, { userAge: '', gender: '', userName: AuthService.getUserName() });
    case ProfileTypes.TOGGLE_LOGIN_OPTION:
      return updateState(state, { isLoginOptionVisible: action.payload });
    case ProfileTypes.TOGGLE_FACEBOOK_LOGIN_LOADER:
      return updateState(state, { isFacebookLoginInProgress: action.payload });
    case ProfileTypes.ON_ENTER_MOBILE:
      return updateState(state, { mobile: action.payload });
    case ProfileTypes.ON_ENTER_OTP:
      return updateState(state, { otp: action.payload });
    case ProfileTypes.DELETE_ACCOUNT:
      return updateState(state, action.payload);
    default:
      return state;
  }
}
